import { DesignCreationMessage } from '@spiffcommerce/core'
import { LineItem } from '../types/types'

export const getLineItems = (finalisedBundle: DesignCreationMessage[], selectedPendantLabels: string[], baseProductName: string) => {
  const timeStamp = Date.now()

  return finalisedBundle
    .map((item, i) => {
      if (!item.externalCartProductVariantId) return

      if (i === 0) {
        return {
          id: item.externalCartProductVariantId,
          quantity: 1,
          properties: {
            _spiffTransactionId: item.transactionId,
            _uniqueTimeStamp: timeStamp,
            'Online - Pendants': selectedPendantLabels
              .map((pendant: string | false, idx: number) => {
                if (!pendant) {
                  console.error('Pendant was falsey during add to cart', pendant)
                  return ''
                }
                return `${idx + 1}. ${pendant}`
              })
              // SASX-197 client back end team requested seven spaces, don't know why
              .join(',       ')
              .toUpperCase()
          }
        }
      }

      return {
        id: item.externalCartProductVariantId,
        quantity: 1,
        properties: {
          _spiffTransactionId: item.transactionId,
          _uniqueTimeStamp: timeStamp,
          NecklaceId: Number(item.externalCartProductVariantId),
          Necklace: baseProductName
        }
      }
    })
    .reverse() as LineItem[]
}
